import UppyUploader from '../UppyUploader';
import withModal from '../withModal';
export default withModal(UppyUploader);